<template>

</template>

<script>
export default {
  name: "forwardUnsettleTransactionList"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/transactionSettlement/forwardUnsettleTransactionList.vue